module.exports = __webpack_public_path__ + "img/avatars.d0065336.png";